import React from "react";
import Navbar from "../../Components/Navbar/index.tsx";
import "./style.css";
import que1 from "../../Assets/About/que1.png";
import que2 from "../../Assets/About/que2.png";
import que3 from "../../Assets/About/que3.png";
import vision from "../../Assets/About/vision.png";
import mission from "../../Assets/About/mission.png";
import main from "../../Assets/About/main.png";
import values from "../../Assets/About/values.png";
import Footer from "../../Components/Footer/index.tsx";
import { Helmet } from "react-helmet";

export default function index() {
  return (
    <>
      <Navbar />
      <Helmet>
        <meta name="description" content="Learn about Singapore Security Force, a trusted security company established in 2021. Discover our mission, vision, and commitment to providing top-notch security services in Singapore." />
        <meta name="keywords" content="about Singapore Security Force, trusted security company Singapore, professional security services, security company history, security services Singapore" />
        <title>Top & Trusted Security Company in Singapore | Singapore Security Force - Trusted Security Company in Singapore</title>

        <meta property="og:title" content="About Us | Singapore Security Force" />
        <meta property="og:description" content="Discover the story behind Singapore Security Force, our mission, vision, and commitment to delivering exceptional security services in Singapore." />
        <meta property="og:image" content="URL-to-your-image.jpg" />
        <meta property="og:url" content="https://singaporesecurityforce.com/about-us" />
        <meta property="og:type" content="website" />
      </Helmet>

      <div className="about-us">
        <div className="about-main">
       
          <div>
            <h3 className="abt-hea">
              Who we are
              <img src={que1} alt="about-us" />
              <img src={que2} alt="about-us" />
              <img src={que3} alt="about-us" />
            </h3>
            <h4 className="mt-3">Founded in 2021,</h4>
            <p className="mt-3 about-para">
              Singapore Security Force Pte Ltd was established in 2021 under the
              Singapore Police Force Ordinance and is fully licensed by the
              Police Licensing Regulatory Department (PLRD). We are authorized
              to provide a wide range of professional security services,
              including uniformed security guards, executive protection, and
              customized security solutions tailored to meet individual client
              needs. Headquartered in Singapore, we proudly operate nationwide,
              delivering reliable and results-driven security services across
              various sectors. Backed by over a decade of industry experience,
              our directors bring deep knowledge and leadership in the private
              security sector — including expertise in safeguarding, access
              control, and private investigations. Their vision is clear: to
              position Singapore Security Force as a trusted and respected brand
              in the security landscape. At the core of our operations is a
              highly trained, disciplined, and motivated team. Guided by a
              dedicated management structure and experienced team leaders, we
              ensure our services are not only efficient but also carried out
              with integrity, professionalism, and strict adherence to
              Singapore’s security regulations
            </p>
          </div>
          <div>
            <img width={500} src={main} alt="about-us" />
          </div>
        </div>
        <div className="manpower-section">
          <div className="content-row">
            <div className="content-item">
              <p>
                <strong>Diverse Workforce:</strong> At SSF, we are proud of our
                diverse workforce, comprising employees from various backgrounds
                and nationalities. Our team includes individuals from a wide
                range of ethnicities, with a mix of expertise and experience to
                serve our clients effectively.
              </p>
            </div>
            <div className="content-item">
              <p>
                <strong>Multicultural Environment:</strong> Our workforce
                includes officers from various communities, including Chinese,
                Indian, and Malay officers, reflecting the multicultural
                environment we foster. Our team members bring a broad range of
                skills, professionalism, and dedication to their work.
              </p>
            </div>
            <div className="content-item">
              <p>
                <strong>Commitment to Excellence:</strong> The average age of
                our officers spans from 31 to 61 years old, with each individual
                contributing to our shared commitment to excellence in service
                delivery.
              </p>
            </div>
          </div>
        </div>
        <div className="comp-scope">
          <div className="icon-wrapper1">
            <div className="icon-circle">
              <img src={vision} alt="about-us" />
            </div>
            <h5>VISION</h5>
            <p>
              To be the trusted global leader in integrated security services,
              combining expert teams and smart technology to proactively protect
              what matters most.
            </p>
          </div>

          <div className="icon-wrapper1">
            <div className="icon-circle">
              <img src={mission} alt="about-us" />
            </div>
            <h5>MISSION</h5>
            <p>
              To deliver tailored, high-quality security solutions with
              excellence, reliability, and professionalism—ensuring safety,
              trust, and peace of mind for every client.
            </p>
          </div>

          <div className="icon-wrapper1">
            <div className="icon-circle">
              <img src={values} alt="about-us" />
            </div>
            <h5>VALUES</h5>
            <p>
              We are driven by integrity, quality, and client loyalty. We value
              teamwork, take initiative, embrace accountability, and believe
              that clear communication is key.
            </p>
          </div>
        </div>
      
      </div>
      <Footer/>
    </>
  );
}
